'use client';

import { Box, Button, Typography } from '@wishket/design-system';

import dynamic from 'next/dynamic';

import DefaultChartMobileLottie from './assets/chart_default_mobile_lottie.json';
import DefaultChartDesktopLottie from './assets/chart_default_desktop_lottie.json';
import { ItemContainer, Root, TypographyChip } from './Chart.parts';
import { ArticleDetailGuestStatisticsChartProps } from './ArticleDetailStatisticsChart.types';

import { Link, Skeleton } from '@/shared/Components';
import { PATH } from '@/shared/constants';

// @ts-ignore - React 19 호환성 문제로 임시 타입 무시
const Lottie = dynamic(() => import('react-lottie'), {
  ssr: false,
  loading: () => <Skeleton className="h-[106px]" />,
});

const ArticleDetailGuestStatisticsChart = ({
  redirectUrlAfterLogin,
}: ArticleDetailGuestStatisticsChartProps) => {
  return (
    <Root>
      <Typography
        variant="body1"
        className="flex flex-wrap items-center gap-1.5"
      >
        <TypographyChip>몇</TypographyChip>년차,
        <TypographyChip>어떤 스킬</TypographyChip>,
        <TypographyChip>어떤 직무</TypographyChip>
        <Typography variant="body1">의 독자들이 봤을까요?</Typography>
      </Typography>
      <ItemContainer className="relative h-fit items-center">
        <Box className="w-full tablet:hidden">
          <Lottie
            options={{
              animationData: DefaultChartMobileLottie,
            }}
            height={106}
          />
        </Box>
        <Box className="hidden w-full tablet:block">
          <Lottie
            options={{
              animationData: DefaultChartDesktopLottie,
            }}
            height={106}
          />
        </Box>
        <Box className="absolute inset-0 flex items-center justify-center">
          <Box className="flex h-[104px] w-[173px] flex-col items-center gap-3 rounded-2xl bg-w-white p-4 shadow-graymedium tablet:w-[243px] desktop:px-6">
            <Typography
              variant="body2"
              className="whitespace-nowrap text-w-gray-900 tablet:hidden"
            >
              {'어떤 독자들이 봤을까요?'}
            </Typography>
            <Typography
              variant="body2"
              className="hidden whitespace-nowrap text-w-gray-900 tablet:block"
            >
              {'어떤 독자들이 봤는지 궁금하다면?'}
            </Typography>
            <Link href={`${PATH.AUTH_LOGIN}?next=${redirectUrlAfterLogin}`}>
              <Button variant="solid" size="sm">
                로그인
              </Button>
            </Link>
          </Box>
        </Box>
      </ItemContainer>
    </Root>
  );
};

export default ArticleDetailGuestStatisticsChart;
